const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

import { axiosInstance as axios } from '../../utils/axios';
import { APP_HOST_API_KEY, PAGINATION_PAGE_SIZE } from '../../config-global';
{
  /***** Get Statements  ******/
}
export const getStatement = createAsyncThunk('get/statement', async () => {
  try {
    const response = await axios.get('/api/depoimentos', {
      params: {
        populate: '*',
      },
    });

    return response.data;
  } catch (e) {}
});

{
  /*** Get FAQ  ******/
}
export const getFaqs = createAsyncThunk('get/faq', async () => {
  try {
    const params = {
      sort: 'Ordem',
    };
    const response = await axios.get('/api/faqs', {
      params: params,
    });

    return response.data;
  } catch (e) {}
});

{
  /******** Get Partners ******/
}

export const getPartners = createAsyncThunk('get/partners', async () => {
  try {
    const response = await axios.get('/api/parceiros', {
      params: {
        populate: '*',
        sort: 'Ordem',
      },
    });
    return response.data;
  } catch (e) {}
});

//***Last news */

export const getLastNews = createAsyncThunk('get/lastNews', async () => {
  try {
    const response = await axios.get('api/noticias', {
      params: {
        populate: '*',
        'sort[0]': 'publishedAt:desc',
        'pagination[limit]': 4,
      },
    });
    return response.data;
  } catch (error) {}
});

/** Statistic  */

export const getStatistic = createAsyncThunk('get/statistic', async () => {
  try {
    const response = await axios.get('/api/estatisticas');

    return response.data;
  } catch (error) {}
});

export const simulateQualification = createAsyncThunk('get/qualification', async (prms) => {
  try {
    const params = {
      'pagination[pageSize]': Number(PAGINATION_PAGE_SIZE ?? 15),
      'pagination[page]': Number(prms?.page ?? 1),
      'populate[0]': 'familia_profissional',
      'populate[1]': 'programa_formativo',
      'populate[2]': 'nivel_formacao',
      'filters[nivel_de_escolaridade][$containsi]': prms?.school_level,
    };

    if (prms?.training_level) {
      params['filters[nivel_formacao][id][$eq]'] = Number(prms.training_level);
    }

    const response = await axios.get('/api/qualificacoes', { params });
    return response.data;
  } catch (error) {}
});

const initialState = {
  statement: {
    isLoading: false,
    data: [],
  },
  faq: {
    isLoading: false,
    data: [],
  },
  partners: {
    isLoading: false,
    data: [],
  },
  news: {
    isLoading: false,
    data: [],
  },
  statistics: [],
  simulated_qualification: {
    isLoading: false,
    education_level: [
      { value: '1', label: '10º Ano' },
      { value: '2', label: '6º Ano' },
      { value: '3', label: '8º Ano' },
    ],
    qualification: [],
  },
};

const homeSlice = createSlice({
  name: 'home',
  initialState,

  extraReducers: {
    [getStatement.pending]: (state) => {
      state.statement.isLoading = true;
    },
    [getStatement.fulfilled]: (state, action) => {
      state.statement.isLoading = false;

      state.statement.data = action.payload?.data;
    },
    [getStatement.rejected]: (state) => {
      state.statement.isLoading = false;
    },
    /** GET FAQS */
    [getFaqs.pending]: (state) => {
      state.faq.isLoading = true;
    },
    [getFaqs.fulfilled]: (state, action) => {
      state.faq.isLoading = false;

      state.faq.data = action.payload?.data;
    },
    [getFaqs.rejected]: (state) => {
      state.faq.isLoading = false;
    },

    /*** GET PARTNERS */
    [getPartners.pending]: (state) => {
      state.partners.isLoading = true;
    },
    [getPartners.fulfilled]: (state, action) => {
      state.partners.isLoading = false;

      state.partners.data = action.payload?.data;
    },
    [getPartners.rejected]: (state) => {
      state.partners.isLoading = false;
    },

    //last news
    [getLastNews.pending]: (state) => {
      state.news.isLoading = true;
    },
    [getLastNews.fulfilled]: (state, action) => {
      state.news.isLoading = false;
      state.news.data = action.payload?.data;
    },
    [getLastNews.rejected]: (state) => {
      state.news.isLoading = false;
    },

    // Statistic
    [getStatistic.fulfilled]: (state, action) => {
      state.statistics = action.payload?.data;
    },
    // simulate qualification
    [simulateQualification.pending]: (state) => {
      state.simulated_qualification.isLoading = true;
    },
    [simulateQualification.fulfilled]: (state, action) => {
      state.simulated_qualification.isLoading = false;
      state.simulated_qualification.data = action.payload?.data;
    },
    [simulateQualification.rejected]: (state) => {
      state.simulated_qualification.isLoading = false;
    },
  },
});

export const homeReducer = homeSlice.reducer;

/*** Statements  **/
export const isStatementLoading = (state) => state.home.statement.isLoading;

export const allStatements = (state) => {
  let data = state.home.statement.data;
  let statements = [];
  if (data) {
    data.forEach((statement) => {
      statements.push({
        id: statement.id,
        author: statement?.attributes?.autor,
        statement: statement?.attributes?.testemunho,
        external_url: statement?.attributes?.url,
        image: APP_HOST_API_KEY +  statement?.attributes?.imagens?.data?.attributes?.url,
      });
    });
  }

  return statements;
};

/*** FAQ ***/
export const isFaqLoading = (state) => state.home.faq.isLoading;

export const allFaqs = (state) => state.home.faq.data;

/*** PARTNERS ***/

export const isPartnersLoading = (state) => state.home.partners.isLoading;

export const allPartners = (state) => {
  let data = state.home.partners.data;
  let partners = [];
  if (data) {
    data.forEach((item) => {
      partners.push({
        id: item.id,
        url: item.attributes?.url,
        image_url: APP_HOST_API_KEY + item.attributes?.imagem?.data?.attributes?.url,
      });
    });
  }

  return partners;
};

/**** LAST NEWS ****/
export const isLoadingLastNews = (state) => state.home.news.isLoading;
export const lastNews = (state) => {
  let data = state.home.news.data;
  console.log('data ...', data);
  let news = [];

  if (data) {
    data.forEach((element) => {
      if (element.attributes?.imagem_destaque?.data?.attributes?.url) {
        news.push({
          id: element.id,
          title: element?.attributes?.titulo,
          publishedAt: element?.attributes?.publishedAt,
          /*imageUrl: element.attributes?.imagem_destaque?.data?.attributes?.url, */
          imageUrl: APP_HOST_API_KEY + element.attributes?.imagem_destaque?.data?.attributes?.url,
        });
      }
    });
  }

  return news;
};

/**** STATISTICS ****/
export const statistics = (state) => {
  let allStatistics = [];

  let data = state.home.statistics;

  if (data) {
    data.forEach((item) => {
      allStatistics.push({
        id: item.id,
        value: item.attributes?.valor,
        title: item.attributes?.titulo,
      });
    });
  }

  return allStatistics;
};

//simulate Qualification
export const educationLevel = (state) => state.home.simulated_qualification.education_level;

export const isSimulatedQualificationLoading = (state) =>
  state.home.simulated_qualification.isLoading;

export const simulatedQualification = (state) => {
  const data = state.qualification.qualifications.data;

  let qualifications = [];

  if (data?.data) {
    data?.data?.forEach((item) => {
      let number_of_modules = item.attributes?.programa_formativo?.length;
      let duration = 0;
      if (number_of_modules > 0) {
        item.attributes?.programa_formativo.forEach((it) => {
          duration += Number(it.carga_horaria ?? 0);
        });
      }
      qualifications.push({
        id: item.id,
        title: item.attributes?.titulo,
        description: item.attributes?.descricao,
        female: item.attributes?.familia_profissional?.data?.attributes?.nome_da_familia,
        level: item.attributes?.nivel_formacao?.data?.attributes?.numero,
        modulo: number_of_modules,
        duration: duration,
        school_level: item.attributes?.nivel_de_escolaridade,
      });
    });
  }
  return {
    data: qualifications,
    meta: {
      page: data?.meta?.pagination?.page,
      totalPages: data?.meta?.pagination?.pageCount,
    },
  };
};
